import styled, { css } from 'styled-components';
import { Popover } from '@material-ui/core';
import HoverPopover from 'material-ui-popup-state/HoverPopover';

export const buttonResetStyles = css`
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  text-align: left;
`;

const popoverStyles = css<{ $offsetTop: boolean }>`
  .MuiPopover-paper {
    background: var(--dcm-popover-bg);
    border-radius: var(--dcm-popover-border-radius);
    box-shadow: var(--dcm-popover-shadow);
    margin-top: ${({ $offsetTop }) => ($offsetTop ? 'var(--dcm-popover-margin-top)' : 0)};
    min-width: var(--dcm-popover-min-width);
    padding: var(--dcm-popover-padding);
  }
`;

export const StyledPopover = styled(Popover)`
  ${popoverStyles}
`;

const popoverNavItemStyles = css<{ $isActive: boolean }>`
  color: var(--dcm-popover-item-color);
  display: block;
  font-size: var(--dcm-popover-item-font-size);
  font-weight: ${({ $isActive }) =>
    $isActive ? 'var(--dcm-popover-item-active-font-weight)' : 'var(--dcm-popover-item-font-weight)'};
  line-height: ${16 / 14};
  padding: var(--dcm-popover-item-padding);
  text-align: left;
  transition: var(--dcm-nav-link-transition);
  width: 100%;
`;

const popoverNavItemHoverStyles = css`
  &:focus,
  &:hover {
    background: var(--dcm-popover-item-hover-bg);
  }
`;

export const PopoverNavItem = styled.div`
  ${popoverNavItemStyles}
`;

export const PopoverNavButton = styled.button`
  ${buttonResetStyles}
  ${popoverNavItemStyles}
  ${popoverNavItemHoverStyles}
`;

export const PopoverNavLink = styled.a`
  ${popoverNavItemStyles}
  ${popoverNavItemHoverStyles}
`;

export const TwoColumnPopoverNavLink = styled(PopoverNavLink)`
  padding: 16px 12px;
`;

export const StyledHoverPopover = styled(HoverPopover)`
  ${popoverStyles}
`;

export const DesktopMq = styled.div`
  @media (max-width: 879px) {
    display: none;
  }
`;

export const MobileMq = styled.div`
  @media (min-width: 880px) {
    display: none;
  }
`;

export const InfoBarMq = styled.div`
  @media (min-width: 1020px) {
    display: none;
  }
`;
